export default __webpack_public_path__ + "static/media/Loading-International-Academy.266099f3.png";